import type { IconSvgObject } from './types';

const ClapperboardIcon: IconSvgObject = [
  ["path", { d: "M2.5 10.5C2.5 6.72876 2.5 4.84315 3.67157 3.67157C4.84315 2.5 6.72876 2.5 10.5 2.5H13.5C17.2712 2.5 19.1569 2.5 20.3284 3.67157C21.5 4.84315 21.5 6.72876 21.5 10.5V13.5C21.5 17.2712 21.5 19.1569 20.3284 20.3284C19.1569 21.5 17.2712 21.5 13.5 21.5H10.5C6.72876 21.5 4.84315 21.5 3.67157 20.3284C2.5 19.1569 2.5 17.2712 2.5 13.5V10.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 8H22", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 8L11.5 2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M13 8L18.5 2.5", stroke: "currentColor", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6.5 17.5H10.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M6.5 13.5L15.5 13.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }]
];

export default ClapperboardIcon;
